module.exports = __webpack_public_path__ + "static/media/Mallorca Way, San Francisco, CA1.f10ffb00.jpg";